import React, { useState, useEffect } from "react";
import baseURL from "../../authComponents/baseURL/BaseURL";
import ReferralModal from "./ReferralModal";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const ReferralsTable = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedReferral, setReferral] = useState(null);
  const [referralName, setReferralName] = React.useState(selectedReferral ? selectedReferral.name : "");
  const [isEditMode, setIsEditMode] = useState(false);

  const handleAddNew = () => {
    setReferral(null);
    setIsEditMode(false);
    setIsOpen(true);
  };

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const response = await baseURL.get("refferals");
        setReferrals(response.data.refferals);
        setLoading(false);
      } catch (error) {
        setError(error.message);
      }
    };
    fetchReferrals();
  }, []);

  const handleEdit = (referral) => {
    setReferral(referral);
    setIsOpen(true);
    setReferralName(referral.name);
  };

  const handleDelete = async (id) => {
    try {
      await baseURL.delete(`/admin/refferal/${id}`);
      setReferrals(referrals.filter((referral) => referral.id !== id));
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCreate = async (data) => {
    try {
      const response = await baseURL.post("/admin/refferal", data);
      if(response.status === 200){
        const newReferral = response.data.refferal;
        setReferrals([...referrals, newReferral]);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleUpdate = async (data) => {
    try {
      if(selectedReferral != null){
        await baseURL.patch(`/admin/refferal/${selectedReferral.id}`, data);
      }else{
        await baseURL.post("/admin/refferal", data);
      }
      const updatedReferrals = referrals.map((r) => (r.id === selectedReferral.id ? { ...r, ...data } : r));
      setReferrals(updatedReferrals);
    } catch (error) {
      setError(error.message);
    }
  };


  return (

    <div className="p-6 max-w-6xl mx-auto">
      
      <div className="flex justify-between mb-4">
        <h1 className="text-2xl font-bold">My Referrals</h1>
        <button className="flex items-center bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow transition-colors disabled:bg-gray-400" onClick={handleAddNew}>Add New </button>
      </div>
      
      <ReferralModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        referral={selectedReferral}
        setIsOpen={setIsOpen}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        referralName={referralName}
      />
      {loading ? (
        <div className="text-center py-10">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#730000] mx-auto"></div>
          <p className="mt-2">Loading...</p>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-b shadow">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-[#730000] text-white text-left text-sm uppercase tracking-wider">
                <tr>
                  <th className="px-3 py-3 text-left text-md font-medium uppercase tracking-wider">ID</th>
                  <th className="px-3 py-3 text-left text-md font-medium uppercase tracking-wider">Name</th>
                  <th className="px-3 py-3 text-left text-md font-medium uppercase tracking-wider">Date Created</th>
                  <th className="px-3 py-3 text-center text-md font-medium uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="text-gray-700 text-sm divide-y divide-gray-200">
                {referrals.map((referral) => (
                  <tr key={referral.id}>
                    <td className="px-3 py-4 font-medium">{referral.id}</td>
                    <td className="px-3 py-4 font-medium">{referral.name}</td>
                    <td className="px-3 py-4">{referral.created_at}</td>
                    <td className="px-3 py-4 gap-1 flex justify-center">
                      <button
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                        onClick={() => handleEdit(referral)}
                      >
                        <FaEdit/>
                      </button>
                      <button
                        className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                        onClick={() => handleDelete(referral.id)}
                      >
                        <MdDelete/>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ReferralsTable;
